import dareDropMark from 'root/src/client/public/logo-daredrop-mark.png';
import dareDropWordmark from 'root/src/client/public/logo-daredrop-wordmark.png';
import { cn } from 'root/src/client/v2/common/helpers/cn';
// The real Dare Drop logo, split into the parachute mark and the "Dare Drop" wordmark so the two sit
// as separate flex children with an explicit gap (the source artwork baked them tightly together).
// Both are white, to sit on the dark redesign chrome (navbar, footer). Both keep the artwork's full
// canvas height, so `items-center` preserves the original vertical relationship (tall mark, low
// wordmark). Callers wrap it in their own link/container; `className` sizes the whole lockup (default
// h-7) and `gapClassName` overrides the spacing between mark and wordmark.
export const RedesignLogo = ({ className, gapClassName = 'gap-2.5' }) => (<span className={cn('flex h-7 items-center', gapClassName, className)}>
		<img src={dareDropMark.src} alt="" aria-hidden="true" className="h-full w-auto"/>
		<img src={dareDropWordmark.src} alt="Dare Drop" className="h-full w-auto"/>
	</span>);
